module.exports = __webpack_public_path__ + "static/media/NZ_Primary_Black_RGB.c1f00522.png";